export default __webpack_public_path__ + "c796a09930d4066bffa2db467a6c0597.png";